import {
    FETCH_BANKCARDVERIFYS
} from '../actions/bankcardVerify';


export const initialState = {
    isFetching: true,
    data: null
};

export const bankcardVerifys = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_BANKCARDVERIFYS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_BANKCARDVERIFYS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./src/redux/reducers/bankcardVerify.js